export default {
  API_ENDPOINT: 'https://lit-plateau-20514.herokuapp.com/api',
  TOKEN_KEY: 'friendly-financial-client-auth-token'
};
